import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { ValidateOTPResponse } from './types';

/**
 * Validates OTP code entered by user during login
 *
 * @method validateOtp
 * @memberof OTP
 * @param  {string} code - OTP code
 * @param  {string} phone? - Optional phone number if validating for OTP phone number initial setup or change
 * @returns {Promise<ValidateOTPResponse>} - Returns validity of OTP code and any errors from validation
 */

export const validateOtp = async (code: string, phone?: string): Promise<ValidateOTPResponse> => {
  const apiRoute = `${Constants.BACKEND_URL}/auth/otp`;
  const url = phone ? `${apiRoute}/validate/${code}/${phone}` : `${apiRoute}/validate/${code}`;

  return httpGet(url)
    .then((response) => {
      if (response?.status === 200 && response?.data.success && response?.data.valid) {
        return { valid: true };
      }
      return { valid: false, error: 'Invalid access code. Please try again.' };
    })
    .catch((error) => {
      return {
        valid: false,
        error: `${error.response?.data?._error?.message}`,
      };
    });
};
